import { render, staticRenderFns } from "./DAdminUserCard.vue?vue&type=template&id=a44e70e0&scoped=true&"
import script from "./DAdminUserCard.vue?vue&type=script&lang=js&"
export * from "./DAdminUserCard.vue?vue&type=script&lang=js&"
import style0 from "./DAdminUserCard.vue?vue&type=style&index=0&id=a44e70e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44e70e0",
  null
  
)

export default component.exports